import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TTrackInvoiceViewRequest,
  TTrackInvoiceViewResponse,
} from "./trackInvoiceView.schema";

export const trackInvoiceView = (axios: IAxiosInstance) => {
  return async (
    params: TTrackInvoiceViewRequest
  ): Promise<TTrackInvoiceViewResponse> => {
    const { invoiceID, accessToken } = params;
    const queryParams = accessToken ? { accessToken } : {};
    const response = await axios.noRetry.post<
      IApiResponse<TTrackInvoiceViewResponse>
    >(`/api/invoices/${invoiceID}/track-view`, {}, { params: queryParams });

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Error tracking invoice view");
  };
};
